import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { FilterRowProps } from "web_myplann/NotificationCenter/Types/FilterRowProps";

export const FilterRowLegacy: FC<FilterRowProps> = ({
	label,
	selected,
	onClick,
	isLast,
	testId,
}) => {
	const theme = useTheme();

	return (
		<ButtonBase
			onClick={onClick}
			data-testid={testId}
			role="radio"
			aria-checked={selected}
			sx={{
				width: "100%",
				justifyContent: "space-between",
				px: 1.6,
				py: 1.4,
				minHeight: 48,
				backgroundColor: theme.palette.common.white,
				...(!isLast && {
					borderBottom: `1px solid ${theme.palette.grey[100]}`,
				}),
				"&:active": { backgroundColor: theme.palette.grey[50] },
			}}
		>
			<Typography fontSize={14} color={theme.palette.grey[900]}>
				{label}
			</Typography>
			{selected && (
				<Box
					sx={{
						width: 22,
						height: 22,
						borderRadius: "50%",
						backgroundColor: theme.palette.secondary.main,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexShrink: 0,
					}}
				>
					<Box
						sx={{
							width: 8,
							height: 8,
							borderRadius: "50%",
							backgroundColor: theme.palette.common.white,
						}}
					/>
				</Box>
			)}
		</ButtonBase>
	);
};
